import { API_URL } from "../api/client";

// What the app's plumbing (src/app/) takes from the transport: the API's
// base, which the service worker needs to know which requests are the API's.
export const apiBase = API_URL;
